import { apiClient } from './apiClient.js';
import type { ApiResponse } from '@onboarding-dashboard/shared';

interface Notification {
  id: string;
  recipientId: string;
  candidateId?: string;
  type: string;
  title: string;
  message: string;
  priority: string;
  isRead: boolean;
  actionUrl?: string;
  createdAt: string;
}

export const notificationService = {
  async list(params?: {
    isRead?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<ApiResponse<{ items: Notification[]; total: number }>> {
    const query = new URLSearchParams();
    if (params?.isRead !== undefined) query.set('isRead', String(params.isRead));
    if (params?.limit) query.set('limit', String(params.limit));
    if (params?.offset) query.set('offset', String(params.offset));
    const qs = query.toString();
    return apiClient.get(`/notifications${qs ? `?${qs}` : ''}`);
  },

  async unreadCount(): Promise<ApiResponse<{ count: number }>> {
    return apiClient.get('/notifications/unread-count');
  },

  async markRead(id: string): Promise<ApiResponse<{ message: string }>> {
    return apiClient.patch(`/notifications/${id}/read`);
  },

  async markAllRead(): Promise<ApiResponse<{ message: string }>> {
    return apiClient.patch('/notifications/read-all');
  },
};
